module.exports = __webpack_public_path__ + "img/title.c5a38274.png";